import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  Components.addType("news-letter", {
    model: {
      defaults: {
        components: /*html*/ `
          <form class="flex items-center space-x-2">
            <input
              type="email"
              placeholder="Enter your email"
              class="w-full max-w-[260px] px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-gray-200"
            />
            <button
              type="submit"
              class="px-4 py-2 bg-gray-800 text-white rounded-md hover:bg-gray-900"
            >
              Subscribe
            </button>
          </form>
        `,
        toolbar: [
          {
            attributes: { class: "fa fa-trash-o" },
            command: "tlb-delete",
          },
          {
            attributes: { class: "fa fa-gear" },
            command: "product-details-edit",
          },
        ],
      },
    },
  });
};
